export default {
    person: {
        wzTZ: 'Annonce de notification coulisses King Honor',
        wzKF: 'Coordonnées du développeur',
        QQ1: 'QQ numéro 1',
        QQ2: 'QQ numéro 2',
        mailbox: 'boîte aux lettres',
        browser: 'Navigateur',
        RecommendedUse: 'Usage recommandé',
        mattersNeedingAttention: 'Notes',
        mattersNeedingAttention1: 'Il est interdit de modifier l’original et de l’utiliser à des fins commerciales',
        mattersNeedingAttention2: 'Cette page est destinée aux développeurs uniquement pour communiquer et apprendre',
        version: 'numéro de version',
    },
    home:{
        wzry:"connectez-vous",
        game:'connectez-vous',
        account:'Veuillez saisir le numéro de compte',
        password:'Veuillez saisir un mot de passe',
        remember:'Mémoriser le mot de passe'
    },
    Login:{
        name:"Bienvenue",
        register:"inscrire",
        logon:"connectez-vous",
        ZY:"La couleur d’automne est légèrement fraîche et sombre",
        ReSelect:"Resélectionner"
    }
};